import React, { useState, useEffect } from 'react';
import convert from 'convert-units';
import {callback} from '../../helpers.js';

import './DistanceInput.scss';

export default (props) => {

	const precision = Math.pow(10, props.precision || 2);
	const [units, setUnits] = useState(props.displayUnits);
	const [value, setValue] = useState(Math.round(convert(props.value).from(props.baseUnits).to(props.displayUnits) * precision)/precision);

	useEffect(()=>{
		setValue(Math.round(convert(props.value).from(props.baseUnits).to(props.displayUnits) * precision)/precision);
	}, [props.value]);

	const massage = (value) => {
		return convert(value).from(props.baseUnits).to(units);
	};

	const onChange = (e) => {
		const out = e.target.value;
		if (e.target.name === 'value') {
			setValue(out);
			callback(props.onChange, [{target: {name: props.name, value: convert(out).from(units).to(props.baseUnits)}}]);
		} else {
			setUnits(out);
			callback(props.onChange, [{target: {name: props.name, value: convert(value).from(out).to(props.baseUnits)}}]);
		}
	}

	return (
		<div className={(props.className || '') + ' weight-input'}>
			<input type="text" name="value" value={value} onChange={onChange} placeholder={props.placeholder} />
			<select name="units" value={units} onChange={onChange}>
				<option value="kg">kg</option>
				<option value="oz">oz</option>
				<option value="lb">lb</option>
			</select>
		</div>
	);
}

